var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"content-loader"},[_c('keep-alive',[_c(_vm.activeComponent.tab,_vm._b({tag:"component",on:{"onSelectTenantCard":_vm.onSelectTenantCard}},'component',{activeComponent: _vm.activeComponent, filterParams: _vm.filterParams, catalogMenus: _vm.catalogMenus},false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }